<template>
  <layout-no-padding>
    <transition name="fadeToggle" mode="out-in">
      <v-flex xs12>
        <v-card hover>
          <v-card-title>Change History</v-card-title>
          <v-flex v-if="subjectId">
            <v-data-table
              :items="audits"
              :headers="headers"
              :rows-per-page-items="pageOptions"
              :loading="loading"
              disable-initial-sort
            >
              <template slot="no-data">
                <div
                  class="text-xs-center grey--text subheading"
                >No audits for this {{ modelObj.text.toLowerCase() }}.</div>
              </template>
              <template slot="items" slot-scope="props">
                <tr>
                  <td v-for="(header, i) in headers" :key="i">
                    <div v-if="typeof props.item[header.value] === 'boolean'">
                      <span v-if="props.item[header.value]">
                        <v-icon color="green">check</v-icon>
                      </span>
                      <span v-else>
                        <v-icon color="red">close</v-icon>
                      </span>
                    </div>
                    <div
                      v-if="typeof props.item[header.value] === 'string'"
                    >{{props.item[header.value] || '-'}}</div>
                    <div
                      v-if="typeof props.item[header.value] === 'number' && header.text.includes('Price')"
                    >${{props.item[header.value].toFixed(2) || '-'}}</div>
                    <div
                      v-if="typeof props.item[header.value] === 'number' && !header.text.includes('Price')"
                    >{{props.item[header.value].toFixed(2) || '-'}} %</div>
                    <div v-if="Array.isArray(props.item[header.value])">
                      <!-- <span v-for="(change, i) in props.item[header.value]" :key="change.field">
                        <audit-change
                          :field="change.field"
                          :to="formatValueString(change.to)"
                          :from="formatValueString(change.from)"
                          :isLastChange="i === props.item[header.value].length -1"
                      ></audit-change>-->
                      <!-- <br v-if="i !== props.item[header.value].length" /> -->
                      <!-- </span> -->
                      <span v-for="(change, i) in props.item[header.value]" :key="change.field">
                        <span>{{ `${change.field}: changed from` }}</span>
                        <span class="font-weight-bold">{{ ` ${formatValueString(change.from)} ` }}</span>
                        <span>to</span>
                        <span class="font-weight-bold">{{ ` ${formatValueString(change.to)}` }}</span>
                        <br v-if="i !== props.item[header.value].length" />
                      </span>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-card-text class="text-xs-center pb-5" v-else>
            <div class="vertical-center-container">
              <v-icon
                class="mr-2"
              >{{ !!model ? $store.state.global.pages[modelObj.icon].icon : $store.state.global.pages.audit.icon }}</v-icon>
              {{ selectModelText }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </transition>
  </layout-no-padding>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import models from '@/modules/audits/mixins/models'
import FormatDates from '@/services/mixins/formatDates'
import AuditService from '@/services/requests/auditService'
import { findChanges } from '@/modules/audits/utils'
import AuditChange from '@/modules/audits/change'
import { debounce } from 'lodash'
export default {
  mixins: [models, FormatDates],
  components: {
    AuditChange
  },
  data() {
    return {
      headers: [
        {
          text: 'Updated At',
          value: 'updatedAt',
          type: 'text'
        },
        {
          text: 'Updated By',
          value: 'updatedBy',
          type: 'text'
        },
        {
          text: 'Changes',
          value: 'changes',
          type: 'text'
        }
      ],
      loading: false,
      pageOptions: [10, 20, 40]
    }
  },
  computed: {
    audits: Store.getSet({ store: 'audits', prop: 'audits' }),
    loadingAudits: Store.getSet({
      store: 'audits',
      prop: 'loadingAudits'
    }),
    subjectId: Store.getSet({ store: 'audits', prop: 'subjectId' }),
    model: Store.getSet({ store: 'audits', prop: 'model' }),
    rates: Store.getSet({ store: 'rates', prop: 'rates' }),
    clients: Store.getSet({ store: 'clients', prop: 'clients' }),
    projects: Store.getSet({ store: 'projects', prop: 'projects' }),
    sites: Store.getSet({ store: 'sites', prop: 'sites' }),
    spoils: Store.getSet({ store: 'spoils', prop: 'spoils' }),
    tips: Store.getSet({ store: 'tips', prop: 'tips' }),
    contractors: Store.getSet({ store: 'contractors', prop: 'contractors' }),
    vehicles: Store.getSet({ store: 'vehicles', prop: 'vehicles' }),
    drivers: Store.getSet({ store: 'drivers', prop: 'drivers' }),
    modelObj() {
      if (!!this.model) {
        return this.getObjByProp(this.model, 'value', this.models)
      } else {
        return null
      }
    },
    selectModelText() {
      let determiner = 'a'
      let subjectText = 'Model'
      let action = 'select'
      if (!!this.model) {
        subjectText = this.modelObj.text
        if (this.modelObj.type === 'transaction') {
          action = 'enter'
          subjectText = `${this.modelObj.text} ID`
        }
        if (this.modelObj.icon === 'allocation') determiner = 'an'
      }
      return `Please ${action} ${determiner} ${subjectText}`
    }
  },
  methods: {
    getAudits() {
      this.loading = true
      AuditService.getAuditsByModelSubjectId(this.subjectId, this.model)
        .then(result => {
          this.loading = false
          for (const audit of result.data.audits) {
            const parsedAudit = JSON.parse(audit.data)
            parsedAudit.updatedAt = this.makeShortDateAndTime(audit.updatedAt)
            parsedAudit.updatedBy = audit.user.name
            this.audits.push(parsedAudit)
          }
          if (this.audits.length > 0) {
            this.audits.push(result.data.subject)
            this.audits = findChanges(this.audits, this.model)
            this.audits = this.audits.reverse()
          }
        })
        .catch(err => {
          this.loading = false
          this.snack({ text: err.response.data.message, color: 'yellow' })
          console.log(err)
        })
    },
    formatValueString(string) {
      switch (string) {
        case '':
          return '" "'
        case undefined:
          return 'not set'
        case null:
          return 'not set'
        default:
          return string.toString()
      }
    }
  },
  watch: {
    subjectId(val) {
      this.audits = []
      if (!!val) {
        this.getAudits()
      }
    },
    model(val) {
      this.subjectId = null
      this.audits = []
    }
  }
}
</script>

<style scoped>
</style>
